<!-- Loading bar -->
<base-loading-bar></base-loading-bar>

<!-- Wrapper -->
<div class="relative flex w-full flex-auto flex-col">
  <!-- Floating Theme Switcher -->
  <div class="fixed top-4 right-4 z-50">
    <theme-switcher></theme-switcher>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>
</div>
